import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

export const assistants = initialState;

const slice = createSlice({
	name: "assistants",
	initialState,
	reducers: {
		setAssistants: (state, action) => {
			return action.payload;
		}
	}
});

export const selectAssistants = state => state.assistants;

export const { setAssistants } = slice.actions;

export default slice.reducer;
